module.exports = __webpack_public_path__ + "c6a057cd9cbcfc880c8f03161a435749.jpg";